/**
 * @author Rahul Nainala
 * @description UI Card for the 3d Which displays the required data from the config
 */
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { useNavigate } from 'react-router-dom';
import { Card, Typography, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';

const { Title, Text } = Typography;

const InfoCard = ({
    cardOpen,
    selectedObjectName,
    selectedModalConfig,
    displayTitle,
    description,
    showUrl,
    urlLink,
    onClose,
    translationCache: translationCacheFromProps
}) => {
    const [translationCache, setTranslationCache] = useState(translationCacheFromProps || []);
    useEffect(() => {
        setTranslationCache(translationCacheFromProps);
    }, [translationCacheFromProps]);

    const translation = (keyword) => {
        return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
    };

    if (!cardOpen || !selectedObjectName || !selectedModalConfig) {
        return null;
    }

    const navigate = useNavigate();
    const hasValidConfig = selectedModalConfig.length > 0 && selectedModalConfig.some(config => config);
    const cardContent = (
        <Draggable handle=".card-title-drag-handle">
            <div
                style={{
                    position: 'fixed',
                    top: '40%',
                    right: 20,
                    zIndex: 9999,
                    minWidth: 350,
                    maxWidth: 420,
                }}
            >
                <Card
                    className="card"
                    title={
                        <div className="card-title-drag-handle" style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            cursor: 'move'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Title level={5} style={{ margin: 0, color: 'white' }}>
                                    {selectedModalConfig.length > 0 && selectedModalConfig[0] ? translation(displayTitle) : ''}
                                </Title>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                {showUrl && (
                                    <Button type='primary' onClick={() => { navigate(urlLink); }}>
                                        {translation("Analytics")}
                                    </Button>
                                )}
                                <CloseOutlined
                                    onClick={onClose}
                                    style={{ color: 'white', transition: 'color 0.3s', cursor: 'pointer' }}
                                    onMouseEnter={e => (e.currentTarget.style.color = '#ff4d4f')}
                                    onMouseLeave={e => (e.currentTarget.style.color = 'white')}
                                />
                            </div>
                        </div>
                    }
                >
                    {hasValidConfig && (
                        <Text type="secondary" className="description">
                            {description}
                        </Text>
                    )}
                    {selectedModalConfig.every(config => !config) ? (
                        <Text style={{ color: 'white' }}>{translation("Configuration Not Implemented")}</Text>
                    ) : (
                        selectedModalConfig.map((config, index) =>
                            config ? (
                                <div
                                    key={index}
                                    style={{
                                        marginBottom: '16px',
                                        border: '1px solid #ddd',
                                        padding: '8px',
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Text>{translation(config.displayName.replace(/_/g, ' '))}</Text>
                                        </div>
                                        <div style={{ fontWeight: 'bold' }}>
                                            {translation(config.parameterDescription) || 'N/A'} :{' '}
                                            <Text>
                                                {translation(config.payload) || 'No Payload'} {config.UOM !== '-' ? translation(config.UOM) : ''}
                                            </Text>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        )
                    )}
                </Card>
            </div>
        </Draggable>
    );
    return ReactDOM.createPortal(cardContent, document.body);
};

const mapStateToProps = (state) => ({
    translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(InfoCard);
